module.exports = __webpack_public_path__ + "static/media/voissatetons.448bc819.jpg";